import { useCallback } from 'react'
import { AdaptiveCarousel, AdaptiveCarouselSlide, Box, Visible, type SwanIconKey } from '@vp/swan'
import { Pillar } from './Pillar'
import type { BrandPillar, BrandPillarsComponentProps } from '../../types/brand-pillars'

export const PillarCarousel = ({ pillarData, carouselA11yText }: BrandPillarsComponentProps) => {
  const isValidPillar = useCallback((pillar: BrandPillar) => Boolean(pillar.icon && pillar.heading && pillar.description), [])

  if (!pillarData?.length) return null

  return (
    <Visible xs>
      <AdaptiveCarousel slidesToShow={1} slidePicker="standard" aria-label={carouselA11yText.label}>
        {pillarData.filter(isValidPillar).map(({ icon, heading, description }) => (
          <AdaptiveCarouselSlide key={`${icon}-${heading}`}>
            <Box paddingLeft="8" paddingRight="8">
              <Pillar icon={icon as SwanIconKey} heading={heading} description={description} justifyContent="center" />
            </Box>
          </AdaptiveCarouselSlide>
        ))}
      </AdaptiveCarousel>
    </Visible>
  )
}
